module.exports = __webpack_public_path__ + "data-table.7ae4f0ebf816c33da874.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/assets/fonts/data-table/data-table.svg
// module id = ../../../../../src/assets/fonts/data-table/data-table.svg
// module chunks = styles